import { Injectable } from '@angular/core';
import { FilterDef } from '@common/data-models/navigation/filter-def';

@Injectable({ providedIn: 'root' })
export class LanguageSettings {
    // Dynamic Labels Map
    public DynamicLabelMap: { [id: string]: string } = {};

    // PST Products Labels
    public PSTWebApPlaybookLabel: string = 'AP PLAYBOOK';
    public PSTWebApStorytellingLabel: string = 'AP STORYTELLING';

    // PST Document Title Products Labels
    public PSTWebApPlaybookTitleLabel: string = 'AP Playbook';
    public PSTWebApStorytellingTitleLabel: string = 'AP Storytelling';
    public PSTWebPlaybookTitleLabel: string = 'Playbook';
    public PSTWebCastTitleLabel: string = 'Cast';
    public PSTWebSideBarTitleLabel: string = 'Show/Hide Sidebar';
    public PSTWebDarkThemeTitleLabel = 'Dark Theme';
    public PSTWebLightThemeTitleLabel = 'Light Theme';
    public PSTWebDiscoverTitleLabel: string = 'Discover';

    // PST Navigation
    public PSTWebViewSettingsTitle: string = 'View Settings';
    public PSTWebHideDetails: string = 'Hide Details';
    public PSTWebShowDetails: string = 'Show Details';
    public PSTWebCopyToClipboard: string = 'Copy to clipboard';

    // PST Login Page
    public PSTWebRememberCredentials: string = 'Remember Me';
    public PSTAutoLoginCredentials: string = 'Auto Login';
    public PSTWebUsernamePlaceholder: string = 'Username';
    public PSTWebPasswordPlaceholder: string = 'Password';
    public PSTWebLoginButton: string = 'Login';
    public PSTWebCollapseAllLabel: string = 'Collapse All';
    public PSTWebExpandAllLabel: string = 'Expand All';
    // PST Session
    public PSTWebSessionExpiredTitle: string = 'Session expired';
    public PSTWebSessionExpiredMessage: string = 'Please, login again';

    // PST Top Bar
    public PSTWebTeamSettingsLabel: string = 'Team Settings';
    public PSTWebCopyViewToClipboard = 'Copy View To Clipboard';

    // PST Side Bar
    public PSTWebNewSectionLabel: string = 'New Section';
    public PSTWebPadLockLabel: string = 'Lock';
    public PSTWebPadUnlockLabel: string = 'Unlock';
    public PSTWebPlusButtonLabel: string = 'Add';
    public PSTWebRenameRemoveTitle: string = 'Rename/Remove';
    public PSTWebRenameLabel: string = 'Rename';
    public PSTWebRemoveLabel: string = 'Remove';
    public PSTWebEditViewLabel: string = 'Edit View';
    public PSTWebDuplicateLabel: string = 'Duplicate';
    public PSTWebDuplicateAsTeamViewLabel: string = 'Duplicate As Team View';

    // PST Search
    public PSTWebSearchPlaceholder: string = 'Search';
    public PSTWebRangeLabel: string = 'Range';

    // PST DIALOG ABOUT
    public PSTWebDialogAboutPlatformLabel: string = 'Platform';
    public PSTWebDialogAboutVersionLabel: string = 'Version';
    public PSTWebDialogAboutDownloadErrorLog: string = 'Download Error Log';
    public PSTWebDialogAboutRights: string = 'Associated Press All rights reserved';
    public PSTWebDialogAboutCloseLabel: string = 'Close';

    // PST Save Planning View Menu
    public PSTWebSaveViewSettings: string = 'Save';
    public PSTWebSaveAsViewSettings: string = 'Save As';
    public PSTWebMakeTeamDefaultView: string = "Make This the Team's Default View";
    public PSTWebMakeGlobalDefaultView: string = 'Make This the Global Default View';
    public PSTWebMakeDefaultView: string = 'Make This My Default View';
    public PSTWebBrowsePlanningViews: string = 'Show All Views';
    public PSTWebCreateNewView: string = 'Create New View';
    public PSTWebEditTeamSettings: string = 'Edit Team Settings';

    public PSTWebSaveAsTitleDefaultSuffix: string = ' (copy)';

    // PST Team View Settings Menu

    public PSTWebSaveTeamViewSettings: string = 'Save Team View Settings';
    public PSTWebSaveAsTeamViewSettings: string = 'Save As Team View';
    public PSTWebBrowseTeamPlanningViews: string = 'Show All Team Views';
    public PSTWebCreateNewTeamView: string = 'Create New Team View';
    public PSTWebExitTeamSettings: string = 'Exit Team Settings';

    public PSTWebHideNavigationBar: string = 'Hide Navigation Bar';
    public PSTWebShowNavigationBar: string = 'Show Navigation Bar';

    public PSTWebMapSettingsBar: string = 'Map Settings';

    public PSTWebCreateNewViewTitle: string = 'New View';
    public PSTWebCreateNewViewShow: string = 'Show';
    public PSTWebCreateNewViewLayout: string = 'Layout';
    public PSTWebNewItemsToggleButton: string = 'New Items';
    public PSTWebCreateNewViewTopicRadio: string = 'Topics';
    public PSTWebCreateNewViewAssignmentRadio: string = 'Assignments';
    public PSTWebCreateNewViewTitlePlaceholder: string = 'Title';

    public PSTWebTopicsLabel: string = 'Topics';
    public PSTWebPublicationItemsLabel: string = 'Publication Items';
    public PSTWebStoriesLabel: string = 'Stories';
    public PSTWebRundownsLabel: string = 'Rundowns';

    // PST Personal Settings Menu
    public PSTWebEditAvatar: string = 'Edit';
    public PSTWebPersonalSettings: string = 'Personal Settings';
    public PSTWebNotificationSettings: string = 'Notification Settings';
    public PSTWebHelp: string = 'Help';
    public PSTWebAbout: string = 'About';
    public PSTWebTeamMembers: string = 'Team Members';
    public PSTWebRegionAndLanguage: string = 'Region and Language';
    public PSTWebDefaultTimeZoneLabel: string = 'Default Time Zone';
    public PSTWebBrowserDefaultTimeZoneLabel: string = 'Browser Default';
    public PSTWebLanguageLabel: string = 'Language';
    public PSTWebDefaultLanguageLabel: string = 'Default Language';
    public PSTWebPublicationChannel: string = 'Publication Channel';
    public PSTWebRTLOriantation: string = 'Right to Left Text Orientation';
    public PSTWebLTROriantation: string = 'Left to Right Text Orientation';
    public PSTWebStartWeekDay: string = 'Start Week Day';

    public PSTWebLogout: string = 'Sign Out';

    public PSTWebRemoveNavigationSectionLabel: string = 'Remove navigation section';
    public PSTWebRemoveNavigationSectionText: string = 'Are you sure you want to remove the {SECTION_LABEL} navigation section?';

    // PST Notification Settings Menu
    public PSTWebNotificationDescription: string = 'Send notification when I have a new Assignment';
    public PSTWebNotificationMobileLabel: string = 'Mobile App';
    public PSTWebNotificationWebLabel: string = 'Web';
    public PSTWebNotificationTextLabel: string = 'Text';
    public PSTWebNotificationTextInputLabel: string = 'Phone Number';
    public PSTWebNotificationEmailLabel: string = 'Email';
    public PSTWebNotificationEmailInputLabel: string = 'Email Address';

    // PSF Filter Panel
    public PSTWebFilterLabel: string = 'Filters';
    public PSTWebRequiredFiltersLabel: string = 'Required';
    public PSTWebOptionalFiltersLabel: string = 'Optional';
    public PSTWebNoFiltersSelectedLabel: string = 'No filters selected';
    public PSTWebFilterRelationshipsLabel: string = 'Relationships';
    public PSTWebAssignmentsFilterLabel: string = 'Assignments';
    public PSTWebMissingAssignmentsFilterLabel: string = 'Missing Assignments';
    public PSTWebFilterRequiredLabel: string = 'Required Filters';
    public PSTWebFilterOptionalLabel: string = 'Optional Filters';
    public PSTWebRefineSearchLabel: string = 'Refine search';
    public PSTWebFirstX: string = 'First {MAX_NUMBER} items shown - ';
    public PSTWebLoadAll: string = 'Load All';
    public PSTWebPinFilterLabel: string = 'Pin Filter';
    public PSTWebDeleteFilterLabel: string = 'Delete Filter';
    public PSTWebAddFilterLabel: string = 'Add Filter';

    // PST List Panel
    public PSTWebSearchLabel: string = 'Search';
    public PSTWebSearchResultsLabel: string = 'Search Results';
    public PSTWebGettingListLoaderLabel: string = 'Getting list';
    public PSTWebNewLabel: string = 'New';
    public PSTWebNewFeedLabel: string = 'New Feed';
    public PSTWebTemplateLabel: string = 'Templates';
    public PSTWebGroupByLabel: string = 'Group By';
    public PSTWebGroupByDateLabel: string = 'Date';
    public PSTWebGroupByTimeLabel: string = 'Time';
    public PSTWebSortByModTimeLabel: string = 'Last Modified';
    public PSTWebSortByAlphabeticalLabel: string = 'Alphabetically By Slug';
    public PSTWebSortByPubTimeLabel: string = 'Published';
    public PSTWebGroupByChannelLabel: string = 'Channel';
    public PSTWebGroupByOwnerLabel: string = 'Owner';
    public PSTWebGroupByStatusLabel: string = 'Status';
    public PSTWebGroupByDepartmentLabel: string = 'Desk';
    public PSTWebGroupByRoleLabel: string = 'My Role';

    public PSTWebGroupByWireCategoryLabel: string = 'Category';
    public PSTWebGroupByWireProviderLabel: string = 'Provider';
    public PSTWebGroupByWireTypeLabel: string = 'Wire Type';
    public PSTWebViewLabel: string = 'Layout';
    public PSTWebSortByLabel: string = 'Sort By';
    public PSTWebSortOrderLabel: string = 'Sort Order';
    public PSTWebGroupSortOrderLabel: string = 'Group Sort Order';
    public PSTWebViewCardsLabel: string = 'Cards';
    public PSTWebViewCardLabel: string = 'Card';
    public PSTWebViewCondensedLabel: string = 'Condensed';
    public PSTWebViewListLabel: string = 'List';
    public PSTWebViewTimelineLabel: string = 'Tile';
    public PSTWebViewMapLabel: string = 'Map';
    public PSTWebViewTrendsLabel: string = 'Trends';
    public PSTWebViewTileLabel: string = 'Tile';
    public PSTWebOwnersLabel: string = 'Owners';
    public PSTWebSlugLabel: string = 'Slug';
    public PSTWebTitleLabel: string = 'Title';
    public PSTWebSummaryLabel: string = 'Summary';
    public PSTWebDescriptionLabel: string = 'Description';
    public PSTWebStatusLabel: string = 'Status';
    public PSTWebSelectStatusLabel: string = 'Select Status';
    public PSTWebDesksLabel: string = 'Desks';
    public PSTWebAssignmentsLabel: string = 'Assignments';
    public PSTWebNewItemLabel: string = 'New Item';
    public PSTWebNewItemsLabel: string = 'New Items';
    public PSTWebMyNewTopics: string = 'Newly Created Items';
    public PSTWebRemoveDate: string = 'Remove Date';
    public PSTWebSettingsBar: string = 'Settings';
    public PSTWebSettingsApproveLabel: string = 'Approve';
    public PSTWebCastTargetPublicationDT: string = 'Target Publication Date and Time';
    public PSTWebCustomFieldLabel: string = 'Custom Field';

    // PST Controls
    public PSTWebSaveButtonLabel: string = 'Save';
    public PSTWebSaveAndNextButtonLabel: string = 'Save & Next';
    public PSTWebSaveAsTemplateButtonLabel: string = 'Save as Template';
    public PSTWebCancelButtonLabel: string = 'Cancel';
    public PSTWebBackButtonLabel: string = 'Back';
    public PSTWebCloseButtonLabel: string = 'Close';
    public PSTWebConfirmButtonLabel: string = 'Confirm';
    public PSTWebBrowseButtonLabel: string = 'Browse';
    public PSTWebApplyButtonLabel: string = 'Apply';
    public PSTWebOkButtonLabel: string = 'Ok';
    public PSTWebInsertButtonLabel = 'Insert';
    public PSTWebStaffIDPlaceholder: string = 'Story Owner';
    public PSTWebSlugPlaceholder: string = 'Slug';
    public PSTWebSummaryPlaceholder: string = 'Summary';
    public PSTWebStatusPlaceholder: string = 'Status';
    public PSTWebDeskPlaceHolder: string = 'Desk';
    public PSTWebTopicTypePlaceholder: string = 'Type';
    public PSTWebModifiedPlaceholder: string = '5 minutes ago';
    public PSTWebNotesLabel: string = 'Notes';
    public PSTWebNotesPlaceholder: string = 'Add notes here';
    public PSTWebAllOption: string = 'All';
    public PSTWebAnyOption: string = 'Any';
    public PSTWebNotAppliedOption: string = 'Not Applied';
    public PSTWebMeOption: string = 'Me';
    public PSTWebBlankOption: string = 'Blank';
    public PSTWebTodayOption: string = 'Today';
    public PSTWebTomorrowOption: string = 'Tomorrow';
    public PSTWebYesOption: string = 'Yes';
    public PSTWebNoOption: string = 'No';
    public PSTWebValueLabel: string = 'Value';
    public PSTWebThisWeekOption: string = 'This Week';
    public PSTWebNextWeekOption: string = 'Next Week';
    public PSTWebWeekAfterNextOption: string = 'Week After Next';
    public PSTWebTodayPlusMinusFiveOption: string = 'Today +/- 5';
    public PSTWebFutureOption: string = 'All Future';
    public PSTWebTodayPlusFiveOption: string = 'Today + 5';
    public PSTWebTodayPlusSevenOption: string = 'Today + 7';
    public PSTWebDateNotAvailableOption: string = 'N/A';
    public PSTWebAssignmentOwnerLabel: string = 'Journalist';
    public PSTWebAssignmentAddLabel: string = 'Assignment';
    public PSTWebStoryAddLabel: string = 'Story';
    public PSTWebCostTypeColumnLabel = 'Cost Type';
    public PSTWebCostColumnLabel = 'Cost';
    public PSTWebCostCurrencyLabel = '$';
    public PSTWebClearAllLabel = 'Clear All';
    public PSTWebClearAllItemsLabel = 'Clear All Items';
    public PSTWebCreateNewTemplateTitlePlaceholder: string = 'Title';
    public PSTWebCreateNewTemplateLabel: string = 'New Template';
    public PSTWebSaveAsTeam: string = 'Save as team';
    public PSTWebSaveAsEnterprise: string = 'Save as enterprise';
    public PSTWebLoadingLabel: string = 'Loading...';
    public PSTWebCreateNewViewLabel: string = 'Create View';
    public PSTWebUpdateViewLabel: string = 'Update View';
    public PSTWebDatePickerClearLabel = 'Clear';
    public PSTWebTimeLabel = 'Time';
    public PSTWebNextLabel = 'Next';
    public PSTWebSelectAllLabel = 'Select All';
    public PSTWebSectionNameLabel = 'Section name';
    public PSTWebStartDateLabel = 'Start date';
    public PSTWebEndDateLabel = 'End date';

    // PST Address Form
    public PSTWebAddressDetails: string = 'Details';
    public PSTWebFormattedAddressPlaceholder: string = 'Location';
    public PSTWebFormattedAddressLabel: string = 'Add Address';

    public PSTWebStreetAddressPlaceholder: string = 'Street Address';
    public PSTWebLocationNamePlaceholder: string = 'Location Name';
    public PSTWebCityPlaceholder: string = 'City';
    public PSTWebStatePlaceholder: string = 'State';
    public PSTWebCountryPlaceholder: string = 'Country';

    public PSTWebCustomCardStreetAddressPlaceholder: string = 'Address - Street Address';
    public PSTWebCustomCardLocationNamePlaceholder: string = 'Address - Location Name';
    public PSTWebCustomCardCityPlaceholder: string = 'Address - City';
    public PSTWebCustomCardStatePlaceholder: string = 'Address - State';
    public PSTWebCustomCardCountryPlaceholder: string = 'Address - Country';

    // PST Topic hover button texts
    public PSTWebTopicHoverDeleteText = 'Delete';
    public PSTWebTopicHoverDuplicateText = 'Duplicate';
    public PSTWebTopicHoverCloneText = 'Clone';
    public PSTWebTopicHoverExpandText = 'Show Details';
    public PSTWebTopicHoverSaveAsTemplateText = 'Save as Template';
    public PSTWebTopicHoverCopyUrlToClipboardText = 'Copy Topic Link to Clipboard';
    public PSTWebAssignmentHoverCopyUrlToClipboardText = 'Copy Assignment Link to Clipboard';
    public PSTWebAddNewTopicText = 'Add New Topic';

    public PSTWebTimeZoneLabel = 'Time Zone';

    // PST Panes
    public PSTWebTagsPane: string = 'Tags';
    public PSTWebCoverageAssignmentsPane: string = 'Coverage Assignments';
    public PSTWebAttachmentsPane: string = 'Attachments';
    public PSTWebContactsPane: string = 'Contacts';
    public PSTWebLinksPane: string = 'Linked Objects';
    public PSTWebTextAssignmentIconTooltip: string = 'Text';
    public PSTWebPhotoAssignmentIconTooltip: string = 'Photo';
    public PSTWebVideoAssignmentIconTooltip: string = 'Video';
    public PSTWebLiveVideoAssignmentIconTooltip: string = 'Live Video';
    public PSTWebAudioAssignmentIconTooltip: string = 'Audio';
    public PSTWebGraphicAssignmentIconTooltip: string = 'Graphic';
    public PSTWebInteractiveAssignmentIconTooltip: string = 'Interactive';
    public PSTWebSocialPromotionAssignmentIconTooltip: string = 'Social Promotion';
    public PSTWebAssignmentDetails: string = 'Assignment Details';
    public PSTWebStoriesPane: string = 'Stories';

    // PST Timeline Day labels (Display names)
    public PSTWebMonday = 'Monday';
    public PSTWebTuesday = 'Tuesday';
    public PSTWebWednesday = 'Wednesday';
    public PSTWebThursday = 'Thursday';
    public PSTWebFriday = 'Friday';
    public PSTWebSaturday = 'Saturday';
    public PSTWebSunday = 'Sunday';

    // PST Timeline Day labels (Display names)
    public PSTWebMON = 'MON';
    public PSTWebTUE = 'TUE';
    public PSTWebWED = 'WED';
    public PSTWebTHU = 'THU';
    public PSTWebFRI = 'FRI';
    public PSTWebSAT = 'SAT';
    public PSTWebSUN = 'SUN';

    // PST Planning Views & Searches
    public PSTWebPlanningViewsLabel = 'Planning Views and Searches';
    public PSTWebPlanningViewsPaneLabel = 'Views';
    public PSTWebSearchesPaneLabel = 'Searches';
    public PSTWebCreateDateLabel = 'Created on';
    public PSTWebRemoveFromNavigation = 'Remove From Navigation';
    public PSTWebAddToNavigation = 'Add To Navigation';
    public PSTWebDeleteViewState = 'Delete';
    public PSTWebDeletePlanningItemLabel = 'WARNING: Deleting the view will remove it from the system permanently, this includes other navigation bars using this view!';
    public PSTWebCreatedInLabel = 'Created In';
    public PSTWebGlobalLabel = 'Global';
    public PSTWebPersonalLabel = 'Personal';
    public PSTWebAllLabel = 'All';

    // PST View State
    public PSTWebDefLayoutLabel = 'Default Layout';
    public PSTWebContentSortOrder = 'Content Sort Order';
    public PSTWebDefContGroupByCriteriaLabel = 'Default Content Group By Criteria';
    public PSTWebDefContSortByCriteriaLabel = 'Default Content Sort By Criteria';
    public PSTWebAddViewTitleLabel = 'Add View Title ...';
    public PSTWebContentTypeLabel = 'Content Type';
    public PSTWebAdvancedSettingsLabel = 'Advanced Settings';
    public PSTWebAddToViewLabel = 'Add To View';
    public PSTWebRemoveAllLabel = 'Remove All';
    public PSTWebAddContentSourceLabel = 'Add Content Source';
    public PSTWebContentLabel = 'Content';
    public PSTWebSelectContentSourceLabel = 'Select Content Source(s)';
    public PSTWebSingleContentViewSourceLabel = 'Single Content View Source';
    public PSTWebMultipleContentViewSourceLabel = 'Multiple Content View Source';
    public PSTWebBrowseLabel = 'Browse';
    public PSTWebConfigureLabel = 'Configure';

    // PST Confirmation Messages
    public PSTWebConfirmDeleteLabel = 'Delete Item';
    public PSTWebConfirmDeletePart1 = 'Are you sure you want to delete the ';

    public PSTWebConfirmFreezePages = 'Freezing pages when MOS Control Active may disrupt your MOS playlist. Do you want to proceed? ';
    public PSTWebConfirmUnfreezePages = 'Are you sure you want to remove the Freeze Page numbers setting? ';
    public PSTWebConfirmCancel = 'Are you sure you wish to discard your changes?';
    public PSTWebConformCancelShort = 'Discard Changes?';
    public PSTWebConfirmDeleteTopicPart2 = ' topic?';
    public PSTWebConfirmDeleteAssignmentPart2 = ' assignment?';
    public PSTWebConfirmDeleteStoryPart2 = ' story?';
    public PSTWebConfirmDeleteTemplatePart2 = ' template?';
    public PSTWebConfirmSaveAsTemplatePart1 = 'Are you sure you want to save as temlate the ';
    public PSTWebConfirmSaveAsTemplatePart2 = ' topic?';
    public PSTWebConfirmChangeTopicGroup = 'This item has multiple values in field {fieldName}. Dropping this here will remove the value where it is dragged from. Do you want to proceed ?';
    public PSTWebClipboardModalTitle = 'Choose Clipboard Template';
    public PSTWebClipboardModalPersonal = 'Personal';
    public PSTWebClipboardModalTeam = 'Team';
    public PSTWebClipboardModalEnterprise = 'Enterprise';
    public PSTWebConfirmDeletePublcationItem = 'publication item?';
    public PSTWebConfirmDeleteKey: string = 'key';

    // PST Slideshow Labels
    public PSTWebPlanningViewType: string = 'Type';
    public PSTWebSingleViewLabel: string = 'Single View';
    public PSTWebSlideshowViewLabel: string = 'Slideshow';
    public PSTWebRefineSlideshowLabel: string = 'Refine';
    public PSTWebSlideshowDelayLabel: string = 'Delay';
    public PSTWebSlideshowIncludeInLabel: string = 'Include in Slideshow';
    public PSTWebSecondsLabel: string = 'seconds';
    public PSTWebSlideshowsPaneLabel: string = 'Slideshows';

    // PST Manage Team Members
    public PSTWebMTMLabel: string = 'Manage Team Members';
    public PSTWebMTMPendingLabel: string = 'Pending';
    public PSTWebMTMActiveLabel: string = 'Active';
    public PSTWebUserGroupSortByStatusLabel: string = 'Status';
    public PSTWebUserGroupSortByRoleLabel: string = 'My Role';
    public PSTWebUserGroupSortByProgramLabel: string = 'Program';
    public PSTWebUserGroupSortByIDLabel: string = 'ID';
    public PSTWebUserGroupSortByFirstNameLabel: string = 'First Name';
    public PSTWebUserGroupSortByLastNameLabel: string = 'Last Name';
    public PSTWebUserGroupSortByEmailLabel: string = 'Email';
    public PSTWebUserHeaderAvatarLabel: string = 'Avatar';
    public PSTWebUserHeaderStatusLabel: string = 'Status';
    public PSTWebUserHeaderInvitationLabel: string = 'Invitation';
    public PSTWebUserHeaderRoleLabel: string = 'My Role';
    public PSTWebUserHeaderDefaultTeamLabel: string = 'Default Team';
    public PSTWebUserHeaderIDLabel: string = 'Member ID';
    public PSTWebUserHeaderFirstNameLabel: string = 'First Name';
    public PSTWebUserHeaderLastNameLabel: string = 'Last Name';
    public PSTWebUserHeaderEmailLabel: string = 'Email';
    public PSTWebUserHeaderSSOEmailLabel: string = 'SSO Logins';
    public PSTWebSendInvitationButtonLabel: string = 'Invite';
    public PSTWebSendedInvitationButtonLabel: string = 'Activated';
    public PSTWebResendInvitationButtonLabel: string = 'Resend';
    public PSTWebNewTeamMembersLabel: string = 'New Team Members';
    public PSTWebAddNewTeamMemberLabel: string = 'Add New Team Member';
    public PSTWebAllTeamMembersLabel: string = 'Active Members';
    public PSTWebPendingTeamMembersLabel: string = 'Pending Invitations';
    public PSTWebConfirmDeleteUserLabel = 'Delete user';
    public PSTWebConfirmDeleteUserMessage = 'Are you sure you want to remove user: ';
    public PSTWebNewMemberLabel: string = 'New Member';
    public PSTWebSaveMemberLabel: string = 'Confirm';
    public PSTSystemConfiguration: string = 'System Configuration';

    // Manage publication channels
    public PSTWebMPCHLabel = 'Manage Publication Channels';
    public PSTWebNPCHLabel = 'New Publication Channel';
    public PSTWebWorkFlowLabel: string = 'Workflow Action';
    public PSTWebScheduleLabel: string = 'Schedule';
    public PSTWebPublicationChannelName: string = 'Name';
    public PSTWebNameLabel: string = 'Name';
    public PSTWebNameOfTeamLabel: string = 'Name of the Team';
    public PSTWebPublicationChannelSections: string = 'Sections';

    public PSTWebConfirmDeletePublicationLabel = 'Delete publication';
    public PSTWebConfirmDeletePublicationMessage = 'Are you sure you want to remove the publication?';

    public PSTWebConfirmDeleteSectionLabel = 'Delete section';
    public PSTWebConfirmDeleteSectionMessage = 'Are you sure you want to remove the section?';

    public PSTWebConfirmAddAllItemsLabel = 'Add all items';
    public PSTWebConfirmAddAllItemsMessage = 'Are you sure you want to add all items to the first section of the publication list?';

    public PSTWebConfirmClearPublicationListLabel = 'Clear publication list';
    public PSTWebConfirmClearPublicationListMessage = 'Are you sure you want to clear the publication list?';

    public PSTWebConfirmAddPublicationToRestrictedChannelLabel = 'Add publication';
    public PSTWebConfirmAddPublicationToRestrictedChannelMessage =
        'You cannot take this action because item "{publicationName}" is already in list {publicationLists}. Do you want to add the item anyway?';

    public PSTWebConfirmEditPublicationChannelMissingValueLabel = 'Missing Value';
    public PSTWebConfirmEditPublicationChannelMessage = "Leaving '{prop}' empty is not allowed.";

    // PST Attachments list
    public PSTWebAttachmentsListDragFile: string = 'Drag file here to upload or ';
    // PST attachment rename
    public PSTWebAttachmentRenameModalTitle = 'File Name (maximum 50 symbols)';
    public PSTWebAttachmentRenameModalInputLabel = 'Attachment Name';

    // PST Native Android
    public PSTWebFileSelectOptionsTitle: string = 'Select Action';
    public PSTWebFileSelectBrowseFiles: string = 'Browse files';
    public PSTWebFileSelectCapturePhoto: string = 'Capture photo from camera';

    public PSTWebDownloading: string = 'Downloading...';

    // Map layout
    public PSTWebZoomToCoverageLabel: string = 'Zoom to Coverage';
    public PSTWebShowTeamLocationsLabel: string = 'Show Team Locations';
    public PSTWebLockMapLocationLabel: string = 'Lock Map Location';

    public PSTWebUploadFileNameTooLong: string = 'You cannot attach files with a name longer than 50 characters.';

    public PSTWebSortOrderTooltipASC: string = 'Ascending';
    public PSTWebSortOrderTooltipDESC: string = 'Descending';

    public PSTWebAttachmentOverLimitLabel: string = 'Attachment size exceeded';
    public PSTWebAttachmentOverLimitText: string = 'You cannot attach files bigger than ';
    public PSTWebAllowedFileSizeText: string = 'Allowed file size:';
    public PSTWebErrorUploadingFileLabel: string = 'Upload file rejected';
    public PSTWebAllowedFileTypesText: string = 'Allowed file types:';

    public PSTWebOpenFullScreenText: string = 'Open Fullscreen';
    public PSTWebChangedAgoLabel: string = 'Updated';
    public PSTWebChangedByLabel: string = 'by';
    public PSTWebAgoLabel: string = 'ago';
    public PSTWebWordsLabel: string = 'words';

    // Draft
    public PSTStaffIDPlaceholder: string = 'Draft Owner';

    // PST Topic Custom Card Fields
    public PSTWebSaveAsTeamDefault: string = 'Save as team default';
    public PSTWebSaveAsEnterpriseDefault: string = 'Save as enterprise default';
    public PSTWebCustomizeTopicCard: string = 'Customize Topic Card';
    public PSTWebSelectFieldLabel = 'Select field';

    // Cast
    public PSTWebStorytellingObjectsLabel: string = 'Objects';
    public PSTWebSavedViewsLabel: string = 'Saved Views';
    public PSTWebCastSearchTabLabel: string = 'Search';
    public PSTWebSavedViewsTabLabel: string = 'Saved';
    public PSTWebRevisionsLabel: string = 'Revisions';
    public PSTWebPublishLabel: string = 'Publish';
    public PSTWebEditSectionsLabel: string = 'Edit Sections';
    public PSTWebSectionsLabel: string = 'Sections';
    public PSTWebCancelEditSectionsLabel: string = 'Cancel Editing';
    public PSTWebSaveSectionsLabel: string = 'Save Sections';
    public PSTWebCreateNewRevisionLabel: string = 'Create New Revision';
    public PSTWebNotPublished: string = 'Not Published';
    public PSTWebPublishedAt: string = 'Published at ';
    public PSTWebPublishedAtByPSTWebPublishedAtBy: string = 'Published at {publicationDate} by {userName}';
    public PSTWebPublishingStatus: string = 'Status: ';
    public PSTWebChannelScheduleNotSupportedLabel: string = 'Channel Schedule not supported';
    public PSTWebChannelScheduleNotSupportedDetailLabel: string = 'Cast supports only Daily Channel Schedule at this time. Your view has the following channel schedule configured: ';
    public PSTWebPublicationListTitle: string = 'List Title';
    public PSTWebPublicationChannelEditionNames: string = 'Edition Names';
    public PSTWebPublicationChannelEditionName: string = 'Edition Name';
    public PSTWebPublicationChannelShowTopics: string = 'Show Topics';
    public PSTWebPublicationChannelShowAssignments: string = 'Show Assignments';
    public PSTWebPublicationChannelShowStories: string = 'Show Stories';
    public PSTWebPublicationChannelRemoveAddedRecords: string = 'Remove Added Records';
    public PSTWebAddAllLabel: string = 'Add All';
    public PSTWebCastObjectsDropDownLabel: string = 'View';
    public PSTWebCastObjectsCreatedBy: string = 'Created By';
    public PSTWebCastObjectsOpenButton: string = 'Open';

    public PSTWebCastLinkViolationErrorLabel: string = 'This Object cannot be deleted because it is included in a Publication List. It presents in the following:';
    public PSTWebErrorDeletingLabel: string = 'Error deleting object';

    public PSTWebCastErrorEditingSectionLabel: string = 'Error editing section';
    public PSTWebCastSectionExistedText: string = 'Section with that title already exists';
    public PSTWebCastSectionEmptyText: string = 'The Section title cannot be empty';

    public PSTWebChannelLabel = 'Channel';
    public PSTWebDefaultViewLabel = 'Default view';
    public PSTWebViewSettingsLabel = 'View Settings';

    public PSTWebWireFlagTooltip: string = 'Create Topic';
    public PSTWebWireTopicFromWireNavigateTooltip: string = 'Create and show new Topic';

    // Discover Wire Attachments full-screen
    public PSTWebWireAttachmentsMediaName: string = 'Media Name';
    public PSTWebWireAttachmentsMediaType: string = 'Media Type';
    public PSTWebWireAttachmentsExitFullscreenMode: string = 'Exit Media Mode';
    public PSTWebWireFullScreenGallery: string = 'Gallery';
    public PSTWebWireFullScreenStory: string = 'Story';
    public PSTWebCreateNewDiscoverWireLabel: string = 'Create New Discover Wire';
    public PSTWebAttachDiscoverWireLabel: string = 'Attach to an existing Discover Wire';
    public PSTWebWireFullScreenWords: string = 'Words';
    public PSTWebWireFullScreenAuthor: string = 'Posted by';
    public PSTWebWireFullScreenAttachTo: string = 'Attach To';

    // Discover Admin panel
    public PSTWebDiscoverAdminSettingsLabel: string = 'Admin Settings';
    public PSTWebDiscoverCredentialsLabel: string = 'Credentials';
    public PSTWebDiscoverFeedsLabel: string = 'Feeds';
    public PSTWebDiscoverAddButton: string = 'Add';
    public PSTWebDiscoverCreateButton: string = 'Create';
    public PSTWebDiscoverEditButton: string = 'Save Changes';

    public PSTWebDiscoverCreateFeedLabel: string = 'Create Feed';

    // Discover New Access Token
    public PSTWebDiscoverNewAccessTokenLabel: string = 'Add New Access Token';
    public PSTWebDiscoverEditAccessTokenLabel: string = 'Editing Access Token';
    public PSTWebDiscoverNewFeedLabel: string = 'Add New Feed Setup';
    public PSTWebDiscoverEditFeedLabel: string = 'Editing Feed Setup';
    public PSTWebDiscoverAddTokenNameLabel: string = 'Add Name';
    public PSTWebDiscoverAddFeedNameLabel: string = 'Add Feed Setup Name';
    public PSTWebDiscoverAPIKeyLabel: string = 'Enter API Key...';

    // Stepper
    public PSTWebDiscoverChooseFeedSourceLabel: string = 'Choose Feed Source';
    public PSTWebDiscoverSelectAccessTokenLabel: string = 'Select Access Token';
    public PSTWebDiscoverSelectProductsLabel: string = 'Select Products';

    public PSTWebDiscoverTokenConfigurationLabel: string = 'Token Configuration';
    public PSTWebDiscoverTokenNameLabel: string = 'Token Name';
    public PSTWebDiscoverURLLabel: string = 'URL';
    public PSTWebDiscoverEnterURLLabel: string = 'Enter URL...';
    public PSTWebDiscoverEnterURLHereLabel: string = 'Enter URL here';
    public PSTWebDiscoverPasswordLabel: string = 'Password';
    public PSTWebDiscoverEnterPasswordLabel: string = 'Enter Password...';
    public PSTWebDiscoverUsernameLabel: string = 'Username';
    public PSTWebDiscoverEnterUsernameLabel: string = 'Enter Username...';
    public PSTWebDiscoverDirectoryLabel: string = 'Directory';
    public PSTWebDiscoverEnterDirectoryLabel: string = 'Enter Directory...';
    public PSTWebDiscoverTypeLabel: string = 'Type';
    public PSTWebDiscoverBAPLabel: string = 'Browse available products...';
    public PSTWebDiscoverEnterAccountNameLabel: string = 'Enter account name';
    public PSTWebDiscoverRSSFeedLabel: string = 'RSS Feed';
    public PSTWebDiscoverWireFeedLabel: string = 'Wire Feed';
    public PSTWebDiscoverWireFeedsLabel: string = 'Wire Feeds';
    public PSTWebDiscoverTwitterFeedFeedLabel: string = 'Twitter Feed';

    // Discover Wire Types
    public PSTWebDiscoverWireTypeRSS: string = 'RSS';
    public PSTWebDiscoverWireTypeAP: string = 'AP';
    public PSTWebDiscoverWireTypeTwitter: string = 'Twitter';
    public PSTWebDiscoverWireTypeFTP: string = 'FTP';

    // Discover Merlin Media Search Full Screen
    public PSTWebDiscoverMerlinPhotosLabel: string = 'Photos';
    public PSTWebDiscoverMerlinVideosLabel: string = 'Videos';
    public PSTWebDiscoverMerlinEntitiesLabel: string = 'Entities';

    // Topic Type
    public PSTWebListValue_PSTTopicType_NoType: string = 'No Type';
    public PSTWebSelectTopicTypesLabel: string = 'Select Topic Types';

    // PST Story
    public PSTWebAddStoryLabel: string = 'Add Story';
    public PSTWebLayoutLabel: string = 'Layout';
    public PSTWebGenerateANewVersion: string = 'Generate a New Version';
    public PSTWebWordsCount: string = 'Words Count:';

    // Tags
    public PSTWebAddTagLabel: string = 'Add Tag';

    // Story Locking
    public PSTWebLockingInProgress: string = 'Locking...';
    public PSTWebLockedSuccess: string = 'Locked';
    public PSTWebLockedByOtherUser: string = 'Locked by another user';

    constructor() {
        FilterDef.LanguageSettings = this;
    }

    public populate(data: Array<{ FieldName: string; FieldValue: string }>) {
        for (let i = 0; i < data.length; i++) {
            if (typeof this[data[i].FieldName] !== 'undefined') {
                this[data[i].FieldName] = data[i].FieldValue ? data[i].FieldValue : '';
            } else {
                this.DynamicLabelMap[data[i].FieldName] = data[i].FieldValue ? data[i].FieldValue : '';
            }
        }

        if (window && window?.['ANDROID_WRAPPER']?.setLanguageSettings) {
            try {
                window['ANDROID_WRAPPER'].setLanguageSettings(JSON.stringify(this));
            } catch (err) {
                console.log(err);
            }
        }
    }

    public get(val: string, def?: string): string {
        if (val) {
            if (val.indexOf('=') > -1) {
                def = val.substr(val.indexOf('=') + 1, val.length);
                val = val.substr(0, val.indexOf('='));
            }

            if (!def) def = val;

            if (this[val]) {
                return this[val];
            }
            if (this.DynamicLabelMap[val]) {
                return this.DynamicLabelMap[val];
            }
            return def;
        }
        return '';
    }
}
